import { SET_WEBAPI_URL } from './actions';
import { Record } from 'immutable';
var InitialState = Record({
  backoffice: null,
  webapi: null
});
var initialState = new InitialState();
/**
 * Revive state based in incoming data
 *
 * @param  {String} backoffice - path to backoffice
 * @param  {String} webapi - path to webapi
 * @return {Object} - new state
 */

function revive(_ref) {
  var backoffice = _ref.backoffice,
      webapi = _ref.webapi;
  return initialState.merge({
    backoffice: backoffice || '/backoffice',
    webapi: webapi || '/webapi'
  });
}
/**
 * API reducer
 *
 * @param  {Object} [state = initialState] - state
 * @param  {Object} action - action
 * @return {Object} state
 */


export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!(state instanceof InitialState)) return revive(state);

  switch (action.type) {
    case SET_WEBAPI_URL:
      return state.set('webapi', action.payload);
  }

  return state;
}